import React from 'react'
import Image from 'components/Image'
import './index.css'

const SRC = 'https://cdn.shopify.com/s/files/1/0569/9957/5718/files/top-deal.png?v=1731688395'

export default function TopDealBadge () {
  return (
    <Image
      src={SRC}
      alt='top deal'
      className='top-deal-badge'
      shouldLazyLoad
    />
  )
}
